/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import Coverage from '../Models/Coverage';
import MLReadOnlyCovTermComponent from '../MLReadOnlyCovTermComponent/MLReadOnlyCovTermComponent';
import MLClauseScheduledItemsComponent from '../MLClauseScheduledItemsComponent/MLClauseScheduledItemsComponent';
import '@xengage/gw-platform-translations';
import metadata from './MLReadOnlyCoverageComponent.metadata.json5';
import styles from './MLReadOnlyCoverageComponent.module.scss';
import messages from './MLReadOnlyCoverageComponent.messages';

function MLReadOnlyCoverageComponent(props) {
    const {
        coverages,
        loading,
        onCovChange,
        onGeneralChange,
        displayHelpMessage,
        optionalHasCheck,
        filterData,
        // isAgent,
        showPremium,
        showMonthlyPremium,
        monthlyPremiumEval,
        isQuoteStale,
        editCoverage,
        showEditCoverage,
        monthlyPremiumEvaluator,
        isOccupancySecondaryOrSeasonal,
        isModernProduct
    } = props;

    /**
     * v9 component should be receiving this too and most of the rendering is tied to this not being true
     * The thing is, none of the instances of this component in v9 is actually sending this parameter,
     * agent or not, this is always false. So, we do the same.
     */
    const isAgent = false;

    const translator = useTranslator();
    const [model, setModel] = useState([]);
    const DELIMITER = '####';
    const isQnB = appConfig.portalCode === 'QB';
    const isGpa = appConfig.portalCode === 'GPA';

    const isLoading = () => loading;
    let isPickYourCoverageBtnVisible = false;

    useEffect(() => {
    let updatedModel = [];
    if (coverages) {
            updatedModel = coverages.map(_.partial(Coverage.create, _, isLoading, onCovChange));
    }
    updatedModel = updatedModel.filter((cov) => cov !== undefined);
    setModel(updatedModel);
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [coverages]);

    const isYesNoOption = useCallback((term) => {
        let isYesNoOptionVal;
        if (term.hasOptions && term.options.length === 2) {
            const yesOptionAvailable = !_.isUndefined(term.options.find((opt) => opt.code === 'true'));
            const noOptionAvailable = !_.isUndefined(term.options.find((opt) => opt.code === 'false'));
            isYesNoOptionVal = yesOptionAvailable && noOptionAvailable;
        } else {
            isYesNoOptionVal = false;
        }
        return isYesNoOptionVal;
    }, []);

    const hasMultipleOptions = useCallback((term) => {
        return term.hasOptions && term.options.length > 1;
    }, []);

    const hasNoOptions = useCallback((term) => {
        return !term.hasOptions || term.options.length === 0;
    }, []);

    const getSingleOption = useCallback((term) => {
        let termValue;
        if (term.hasOptions) {
            const chosenTerm = term.options.find((opt) => opt.code === term.value);
            termValue = (chosenTerm || term.options[0]).name;
        } else {
            termValue = term.newValue;
        }
        return termValue;
    }, []);

    const getChosenTermValue = useCallback((term) => {
        let termValue;
        if (term.hasOptions) {
            const chosenTerm = term.options.find((opt) => opt.code === term.value);
            termValue = (chosenTerm || term.options[0]).name;
        } else {
            termValue = term.newValue;
        }
        return termValue;
    }, []);

    const getOptionName = useCallback((optionsTerm) => {
        if (!_.isUndefined(optionsTerm.options)) {
            const option = optionsTerm.options.find((element) => element.code === optionsTerm.value);
            return option ? option.name : '';
        }
        return undefined;
    }, []);

    const hasSingleOption = useCallback((term) => {
        return term.hasOptions && term.options.length === 1;
    }, []);

    const coverageSelectedChanged = useCallback((isSelected, coverage) => {
        coverage.selected = isSelected;
    }, []);

    const isDescriptionDuplicated = (covOrTerm) => {
        return covOrTerm.name === covOrTerm.description;
    };

    const hasReadMore = (covOrTerm) => {
        return covOrTerm.description ? covOrTerm.description.includes(DELIMITER) : false;
    };

    const displayBeforeReadMoreContent = (covOrTerm) => {
        return covOrTerm.description && covOrTerm.description.split(DELIMITER)[0];
    };

    const getPopoverContent = useCallback((covOrTerm) => {
        if (hasReadMore(covOrTerm)) {
            return covOrTerm.description.split(DELIMITER)[1];
        }
        return covOrTerm.description;
    }, []);

    const isNotSPPAndVPP = (cov) => {
        return cov.code_ML !== 'HOPValuablePersonalProperty' && cov.code_ML !== 'HOPScheduledPersonalProperty';
    };

    const isSelfInsuredRetention = (cov) => {
        return cov.code_ML === 'PUPSelfInsuredRetention_ML';
    };

    const checkCovVisibility = (cov, covIndex) => {
        const isCovSelected = cov.required || (!cov.required && cov.selected);
        // added cov code check to hide for opt coverages
        if ((covIndex === 0  && isCovSelected && cov.code_ML !== 'HOPAdditionalFeatures_ML') || (covIndex === 1 && cov.code_ML !== 'HOPBackupSewersDrainsPump' && !isPickYourCoverageBtnVisible)) {
            isPickYourCoverageBtnVisible = true;
            return isPickYourCoverageBtnVisible;
        };
        return false;  
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            editCoverage
        },
        resolveComponentMap: {
            mlreadonlycovtermcomponent: MLReadOnlyCovTermComponent,
            mlclausescheduleitemscomponent: MLClauseScheduledItemsComponent
        }
    };

    const generateCoverageOverrides = useCallback(() => {
        const coverageOverrides = _.filter(model, filterData).filter(isNotSPPAndVPP).map((cov, covIndex) => {
            const hideTermValueForCoverage = isOccupancySecondaryOrSeasonal && ['HOPCovE', 'HOPCovF'].includes(cov?.code_ML)
            return {
                [`readOnlyCovIterableContainer${covIndex}`]: {
                    visible: (cov.required || (!cov.required && cov.selected))
                },
                [`readOnlyCovContentHeader${covIndex}`]: {
                    visible: cov.required || hasReadMore(cov)
                },
                [`readOnlyCovDisplayBeforeReadMore${covIndex}`]: {
                    content: displayBeforeReadMoreContent(cov),
                    visible: false
                },
                [`readOnlyCovTooltip${covIndex}`]: {
                    visible: (isQnB || displayHelpMessage) && cov.description && !isDescriptionDuplicated(cov),
                    tooltipContent: cov.required ? cov.description : getPopoverContent(cov)
                },
                [`mlReadOnlyCovsTableContainer${covIndex}`]: {
                    visible: !isAgent && !_.isEmpty(cov.terms)
                },
                [`tableRowHeader${covIndex}`]: {
                    className: showPremium || showMonthlyPremium ? 'table-row three-columns' : 'table-row'
                },             
                 [`headerCoverages${covIndex}`]: {
                    visible: !hideTermValueForCoverage,
                },
                [`headerLimits${covIndex}`]: {
                   visible: !hideTermValueForCoverage,
                    className: showPremium || showMonthlyPremium ? 'mid-column light' : 'right-column light font-weight--bold'
                },
                [`headerPremium${covIndex}`]: {
                    visible: !!(showPremium || showMonthlyPremium),
                    content: showMonthlyPremium ? translator(messages.monthlyPremium) : translator(messages.premium)
                },
                [`mlReadOnlyCovTermComponent${covIndex}`]: {
                    index: covIndex,
                    coverage: cov,
                    getChosenTermValue,
                    displayBeforeReadMoreContent,
                    displayHelpMessage,
                    isDescriptionDuplicated,
                    hasReadMore,
                    getPopoverContent,
                    isSelfInsuredRetention,
                    showPremium,
                    showMonthlyPremium,
                    monthlyPremiumEvaluator,
                    isModernProduct,
                    isOccupancySecondaryOrSeasonal
                },
                [`covScheduleItems${covIndex}`]: {
                    visible: (cov.required || cov.selected) && cov.scheduledItems_ML,
                    clause: cov,
                    onGeneralChange,
                    onCovChange,
                    loading,
                    isQuoteStale,
                    readOnly: true,
                    isModernProduct
                },
                [`readOnlyEditCovDiv${covIndex}`]: {
                    visible: (showEditCoverage && isQnB && checkCovVisibility(cov, covIndex)) || isGpa ? showEditCoverage : false,
                },
                [`readOnlyEditCovBtn${covIndex}`]: {
                    content: (isQnB && isPickYourCoverageBtnVisible) ? translator(messages.pickYourCoverageLevel) : translator(messages.editCoverage),
                    visible: !isQnB
                }
            };
        });

        return Object.assign({}, ...coverageOverrides);
    }, [model, filterData, displayHelpMessage, getPopoverContent, isAgent, showPremium, showMonthlyPremium, translator, getChosenTermValue, monthlyPremiumEvaluator, onGeneralChange, onCovChange, loading, isQuoteStale, showEditCoverage]);

    const overrides = {
        readOnlyCovContainer: {
            visible: !_.isEmpty(model)
        },
        readOnlyCovIterable: {
            data: _.filter(model, filterData).filter(isNotSPPAndVPP)
        },
        ...generateCoverageOverrides()
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLReadOnlyCoverageComponent.propTypes = {
    coverages: PropTypes.shape({}),
    showMonthlyPremium: PropTypes.bool,
    loading: PropTypes.bool,
    onCovChange: PropTypes.func,
    onGeneralChange: PropTypes.func,
    displayHelpMessage: PropTypes.bool,
    filterData: PropTypes.bool,
    isAgent: PropTypes.bool,
    showPremium: PropTypes.bool,
    monthlyPremiumEval: PropTypes.func,
    isQuoteStale: PropTypes.bool,
    editCoverage: PropTypes.func,
    showEditCoverage: PropTypes.bool,
    monthlyPremiumEvaluator: PropTypes.func,
    isModernProduct:PropTypes.bool,
    isOccupancySecondaryOrSeasonal:PropTypes.bool,
};

MLReadOnlyCoverageComponent.defaultProps = {
    isAgent: false,
    showEditCoverage: true
};

export default MLReadOnlyCoverageComponent;
